import PolicyEditor from './PolicyEditor'

const Terms = () => (
  <PolicyEditor
    pageName='terms-and-conditions'
    label='Terms & Conditions'
    defaults={{
      title: 'Terms & Conditions',
      subtitle: 'Legal',
    }}
  />
)

export default Terms
